__webpack_require__.p = "https://bmidxbsloveniaplpreprod.netlify.app/";